module.exports = __webpack_public_path__ + "static/worlds-best-speaker-f554512ea12bd96bdf205d32d7fe4dbd.jpg";